import React from "react";
import { nameFor } from "../utils/displayName";

export type ProfileCardUser = {
  createdAt?: string | null;
  phone?: string | null;
  userProfileByUserId?: {
    fullName?: string | null;
    displayName?: string | null;
    hometown?: string | null;
    school?: string | null;
    work?: string | null;
    interests?: string | null;
    bio?: string | null;
    preferredSaunaTempF?: number | null;
  } | null;
};

type Props = {
  user: ProfileCardUser;
  heading?: string;
  sinceLabel?: "Host" | "Member";
  headerRight?: React.ReactNode;
  showPhone?: boolean;
  style?: React.CSSProperties;
};

export default function ProfileCard({
  user,
  heading = "Meet your host",
  sinceLabel = "Host",
  headerRight,
  showPhone = false,
  style,
}: Props) {
  const p = user.userProfileByUserId;
  const displayName = nameFor(p, "Host");
  const since = user.createdAt ? new Date(user.createdAt).getFullYear() : null;
  const details: { label: string; value: string }[] = [
    showPhone && user.phone    ? { label: "Phone",       value: user.phone }                          : null,
    p?.hometown                ? { label: "Hometown",    value: p.hometown }                          : null,
    p?.school                  ? { label: "School",      value: p.school }                            : null,
    p?.work                    ? { label: "Work",        value: p.work }                              : null,
    p?.interests               ? { label: "Interests",   value: p.interests }                         : null,
    p?.preferredSaunaTempF != null ? { label: "Preferred temp", value: `${p.preferredSaunaTempF} °F` } : null,
  ].filter(Boolean) as { label: string; value: string }[];

  return (
    <div style={{ border: "1px solid #e5e7eb", borderRadius: 8, padding: 20, background: "#fff", ...style }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 4 }}>
        <h4 style={{ margin: 0, fontSize: 14, fontWeight: 600 }}>{heading}</h4>
        {headerRight}
      </div>
      <p style={{ margin: "0 0 2px", fontSize: 16, fontWeight: 600 }}>{displayName}</p>
      {since && (
        <p style={{ margin: "0 0 12px", fontSize: 13, color: "#6b7280" }}>{sinceLabel} since {since}</p>
      )}
      {p?.bio && (
        <p style={{ fontSize: 14, lineHeight: 1.6, margin: "0 0 12px" }}>{p.bio}</p>
      )}
      {details.length > 0 && (
        <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
          {details.map(({ label, value }) => (
            <p key={label} style={{ margin: 0, fontSize: 13 }}>
              <span style={{ fontWeight: 600, color: "#374151" }}>{label}:</span>{" "}
              <span style={{ color: "#6b7280" }}>{value}</span>
            </p>
          ))}
        </div>
      )}
    </div>
  );
}
